import {
  McpEntityRefSchema,
  McpPromptComponentMetadataSchema,
  McpResourceComponentMetadataSchema,
  McpServerComponentMetadataSchema,
  McpToolComponentMetadataSchema,
} from './mcp-component-metadata.schema';
import type {
  McpEntityRefDto,
  McpPromptComponentMetadataDto,
  McpResourceComponentMetadataDto,
  McpServerComponentMetadataDto,
  McpToolComponentMetadataDto,
} from './mcp-component-metadata.schema';

export const parseMcpServerComponentMetadata = (
  metadata: unknown,
): McpServerComponentMetadataDto | null => {
  const parsed = McpServerComponentMetadataSchema.safeParse(metadata);
  return parsed.success ? parsed.data : null;
};

export const parseMcpToolComponentMetadata = (
  metadata: unknown,
): McpToolComponentMetadataDto | null => {
  const parsed = McpToolComponentMetadataSchema.safeParse(metadata);
  return parsed.success ? parsed.data : null;
};

export const parseMcpPromptComponentMetadata = (
  metadata: unknown,
): McpPromptComponentMetadataDto | null => {
  const parsed = McpPromptComponentMetadataSchema.safeParse(metadata);
  return parsed.success ? parsed.data : null;
};

export const parseMcpResourceComponentMetadata = (
  metadata: unknown,
): McpResourceComponentMetadataDto | null => {
  const parsed = McpResourceComponentMetadataSchema.safeParse(metadata);
  return parsed.success ? parsed.data : null;
};

export const resolveMcpResourceComponentUri = ({
  metadata,
  componentName,
}: {
  metadata: unknown;
  componentName: string;
}): string => {
  const resourceMetadata = parseMcpResourceComponentMetadata(metadata);
  if (resourceMetadata) {
    return (
      resourceMetadata.uri ??
      resourceMetadata.uriTemplate ??
      resourceMetadata.mcpEntity.resourceUri ??
      resourceMetadata.mcpEntity.resourceUriTemplate ??
      componentName
    );
  }
  const mcpEntity = parseMcpEntityRef(
    metadata && typeof metadata === 'object' && !Array.isArray(metadata)
      ? (metadata as { mcpEntity?: unknown }).mcpEntity
      : undefined,
  );
  if (mcpEntity?.resourceUri?.trim()) {
    return mcpEntity.resourceUri;
  }
  if (mcpEntity?.resourceUriTemplate?.trim()) {
    return mcpEntity.resourceUriTemplate;
  }
  if (
    metadata &&
    typeof metadata === 'object' &&
    !Array.isArray(metadata) &&
    typeof (metadata as { uriTemplate?: unknown }).uriTemplate === 'string'
  ) {
    return (metadata as { uriTemplate: string }).uriTemplate;
  }
  return componentName;
};

export const parseMcpEntityRef = (value: unknown): McpEntityRefDto | null => {
  const parsed = McpEntityRefSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
};
